import React from "react";
import "./RecurringScopeModal.css";

function RecurringScopeModal({ actionLabel, onThisOnly, onThisAndFollowing, onCancel }) {
  const handleOverlayClick = (e) => {
    if (e.target.classList.contains("modal-overlay")) {
      onCancel();
    }
  };

  return (
    <div className="modal-overlay" onClick={handleOverlayClick}>
      <div className="modal recurring-scope-modal" onClick={(e) => e.stopPropagation()}>
        <h2>Apply recurring change</h2>
        <p className="recurring-scope-copy">
          This event belongs to a repeating series. Choose how to apply this {actionLabel}.
        </p>

        <div className="recurring-scope-actions">
          <button className="recurring-scope-btn recurring-scope-btn--primary" onClick={onThisOnly}>
            Just this event
          </button>
          <button className="recurring-scope-btn recurring-scope-btn--danger" onClick={onThisAndFollowing}>
            This and all following
          </button>
        </div>

        <div className="modal-footer-row">
          <button className="cancel-btn" onClick={onCancel}>Cancel</button>
        </div>
      </div>
    </div>
  );
}

export default RecurringScopeModal;
